import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { Http } from './http'
import { getToken } from './token'

const API_RESTORE = '/send_email/'

export const middleware = {
  isGuest: function (_to: RouteLocationNormalized, _from: RouteLocationNormalized, next: NavigationGuardNext) {
    if (getToken()) next({ path: '/' })
    next()
  },
  isAuth: function (_to: RouteLocationNormalized, _from: RouteLocationNormalized, next: NavigationGuardNext) {
    if (!getToken()) {
      next({ name: 'login' })
    }
    next()
  }
}

export const restore = async (login: string) => {
  const result: { result: object; error: object; isSend: boolean } = {
    result: {},
    error: {},
    isSend: false
  }
  try {
    const response = await Http.post(API_RESTORE, {
      message: `ВОССТАНОВЛЕНИЕ ПАРОЛЯ ДЛЯ ${login}`,
      receiver_email: 'support@ykvik.com',
      sender_email: 'reg@ykvik.com',
      subject: 'ВОССТАНОВЛЕНИЕ ПАРОЛЯ'
    })
    result.result = response.data
    result.isSend = true
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (e: any) {
    if (e.response) {
      // eslint-disable-next-line no-return-assign
      return (result.error = e.response.data.error)
    }
    result.error = e
  }

  return result
}
